/**
 * Whether a failed request for a Stripe onboarding link is the API answering
 * no, rather than something breaking.
 *
 * Since 8 October 2026 the API opens a connected account only for somebody
 * who holds a pro role that was not withdrawn, and answers 403 to everybody
 * else. The onboarding screen does not know that: a notification about held
 * earnings, a Stripe return link or an old route still brings a former pro to
 * it, and its button asks anyway. The state then rethrew the 403, Angular's
 * error handler reported it, and on 27 October 2026 it reached Sentry as an
 * unhandled crash (CAPACITOR-1G) although nothing had crashed.
 *
 * Every 4xx this route sends is written on purpose: 400 for a country Stripe
 * does not serve, 403 for a pro role that is not active, 404 for a missing
 * profile. Those are answers, already drawn on the screen as its error. What
 * stays reported is what nobody chose: a 5xx, or no answer at all (status 0).
 *
 * `status` is read structurally so this file depends on nothing from Angular.
 */
export const theRefusalIsAnAnswer = (error: unknown): boolean => {
  const status = (error as { status?: unknown } | null)?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
};
